import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import auctions from './modules/auctions'
import loader from './modules/loader'
import searchResults from './modules/searchResults'
import singleLot from './modules/singleLot'
import marketPriceModal from './modules/marketPriceModal'
import bids from './modules/bids'
import bidModal from './modules/bidModal'
import bidsModals from './modules/bidsModals'
import placeBid from './modules/placeBid'
import user from './modules/user'
import groups from './modules/groups'
import users from './modules/users'
import cars from './modules/cars'
import car from './modules/car'
import singleCar from './modules/singleCar'
import userSideBar from './modules/userSideBar'
import shippingGroup from './modules/shippingGroup'
import invoice from './modules/invoice'
import pricePlans from './modules/pricePalns'
import favoriteSearches from './modules/favoriteSearches'
import inlandPrices from './modules/inlandPrices'
import inlandCompanies from './modules/inlandCompanies'
import proformaInvoice from './modules/proformaInvoice'
import proformaInvoiceCostItems from './modules/proformaInvoiceCostItems'
import proformaInvoiceSalesItems from './modules/proformaInvoiceSalesItems'
import customInvoice from './modules/customInvoice'
import customInvoiceCostItems from './modules/customInvoiceCostItems'
import customInvoiceSalesItems from './modules/customInvoiceSalesItems'
import sInvoice from './modules/sInvoice'
import resultBiddingModal from './modules/resultBiddingModal'
import resultGallery from './modules/resultGallery'
import statistics from './modules/statistics'
import profit from './modules/profit'
import carHiddenFields from "./modules/carHiddenFields";
import stockCars from "./modules/stockCars";
import bankingTransactions from "./modules/bankingTransaction";
import onePriceList from "./modules/onePriceList";
import statisticsOPL from "./modules/statisticsOPL";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        auth,
        auctions,
        loader,
        searchResults,
        singleLot,
        marketPriceModal,
        bids,
        bidModal,
        bidsModals,
        placeBid,
        user,
        groups,
        users,
        cars,
        singleCar,
        car,
        userSideBar,
        shippingGroup,
        invoice,
        pricePlans,
        favoriteSearches,
        inlandPrices,
        inlandCompanies,
        proformaInvoice,
        proformaInvoiceCostItems,
        proformaInvoiceSalesItems,
        customInvoice,
        customInvoiceCostItems,
        customInvoiceSalesItems,
        sInvoice,
        resultBiddingModal,
        resultGallery,
        statistics,
        profit,
        carHiddenFields,
        stockCars,
        bankingTransactions,
/*        onePriceList,
        statisticsOPL*/
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js